exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "benefit-request-modal successful-action .modal-content .modal-body .period-name{font-size:18px;line-height:1.17;text-align:center;color:#666}benefit-request-modal successful-action .modal-content .modal-body .description{max-width:380px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/benefitRequestModal/benefitRequestModal.scss
// module id = 1652
// module chunks = 0